/* eslint-disable react-hooks/exhaustive-deps */
import useRealParams from 'hook/UseRealParams';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { ProductTestService } from 'services/ProductTestService';
import { useHistory } from 'react-router-dom';
import { GENERATE_ROUTE, ROUTES } from 'utils/constants/routes';

const LaboratoryTestContext = createContext({});

// noinspection JSValidateTypes
/**
 * Return object containing Laboratory Test information apart from the name already available in the url
 * @returns {LaboratoryInfo}
 */
export const useLaboratoryTestInfo = () => useContext(LaboratoryTestContext);

export const LaboratoryTestInfoProvider = ({ children }) => {
  const { ptldId } = useRealParams();
  const [laboratoryTestGlobalStats, setlaboratoryTestGlobalStats] = useState({});
  const history = useHistory();

  useEffect(() => {
    ProductTestService.getProductTestDetails(ptldId).then(setlaboratoryTestGlobalStats)
      .catch(errorMessage => {
        history.push(GENERATE_ROUTE(ROUTES.ERROR), { errorMessage: errorMessage });
      })
  }, [ptldId]);

  return (
    <LaboratoryTestContext.Provider
      value={laboratoryTestGlobalStats}
    >
      {children}
    </LaboratoryTestContext.Provider>
  );
};